import React from 'react';
import Aux from '../../../hoc/Auxiliary';
import Button from '../../UI/Button/Button';

class OrderSummary extends React.Component {

  //This could be a functional component, doesn't have to be a class component

  render() {
  const ingredientSummary = Object.keys(this.props.ingredients)
    .map(e => {
      return <li key={e}>
          <span style={{textTransform: 'capitalize' }}>{e}</span>: {this.props.ingredients[e]}
        </li>
    });
    return (
    <Aux>
      <h3>Your Order</h3>
      <p>A delicious burger with the following ingredients:</p>
      <ul>
        {ingredientSummary}
      </ul>
      <p><strong>Total Price: {this.props.price.toFixed(2)}</strong></p>
      <p>Continue to Checkout?</p>
      <Button btnType="Danger" clicked={this.props.purchaseCancelled}>CANCEL</Button>
      <Button btnType="Success" clicked={this.props.purchaseContinued}>CONTINUE</Button>
    </Aux>
    );
  }
}
export default OrderSummary;
